import { useEffect } from 'react'

import { useData } from '@/hooks/useLocale'

/** Set the tab title. Home passes nothing and gets the name plus tagline. */
export function useTitle(title) {
  const { SITE_NAME, SITE_TAGLINE } = useData()
  useEffect(() => {
    document.title = title
      ? `${title} · ${SITE_NAME}`
      : `${SITE_NAME} · ${SITE_TAGLINE}`
  }, [title, SITE_NAME, SITE_TAGLINE])
}
